// Este codigo fue generado por Github Copilot Chat
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnChanges {
  // Título del modal
  @Input() title: string | undefined;
  // El contenido a mostrar. Puede ser una tabla (array de arrays) o un string
  @Input() data: string | string[][] = '';
  // Controla si se muestra el modal
  @Input() isOpen = false;
  // Opcionales: ancho y alto en porcentaje
  @Input() width?: number;
  @Input() height?: number;
  // Opcionales: ancho y alto en px
  @Input() widthPx?: number;
  @Input() heightPx?: number;
  // Opcionales: ancho y alto máximo en px
  @Input() maxWidthPx?: number;
  @Input() maxHeightPx?: number;
  // Controla si el modal se puede cerrar haciendo clic fuera o con Escape (por defecto: true)
  @Input() closeOnBackdrop = true;
  // Evento para cerrar el modal
  @Output() closeModal = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      if (this.isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  }

  onClose() {
    this.closeModal.emit();
  }

  onBackdropClick() {
    if (this.closeOnBackdrop) {
      this.closeModal.emit();
    }
  }

  onEscapeKey() {
    if (this.closeOnBackdrop) {
      this.closeModal.emit();
    }
  }

  // Determina si rows es una tabla (array de arrays)
  isTable(value: unknown): value is string[][] {
    return Array.isArray(value) && Array.isArray(value[0]);
  }

  // Calcula los estilos dinámicos del modal
  getModalStyles(): Record<string, string> {
    const styles: Record<string, string> = {};

    // Prioridad: px sobre porcentaje
    if (this.widthPx !== undefined) {
      styles['width'] = `${this.widthPx}px`;
    } else if (this.width !== undefined) {
      styles['width'] = `${this.width}%`;
    }

    if (this.heightPx !== undefined) {
      styles['height'] = `${this.heightPx}px`;
    } else if (this.height !== undefined) {
      styles['height'] = `${this.height}%`;
    }

    if (this.maxWidthPx !== undefined) {
      styles['max-width'] = `${this.maxWidthPx}px`;
    }

    if (this.maxHeightPx !== undefined) {
      styles['max-height'] = `${this.maxHeightPx}px`;
    }

    return styles;
  }
}
// Este codigo fue generado por Github Copilot Chat
